export default "/images/unavailable-blueprint.png?222b5d213572b5166f333c4b69bfc24f";